import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../../services/socket.service';
import { Subscription } from 'rxjs/Subscription';
import { NgZone } from '@angular/core';
import {take} from 'rxjs/operators';
import {NotificationService} from '../../services/notification.service';
import {PatientService} from '../../services';

@Component({
  selector: 'app-sos-alert',
  templateUrl: './sos-alert.component.html',
  styleUrls: ['./sos-alert.component.scss']
})
export class SosAlertComponent implements OnInit, OnDestroy {

  @Input() user;
  private subscription: Subscription;
  public alarm;
  public notifySound = true;

  constructor(
    public activeModal: NgbActiveModal,
    private socketService: SocketService,
    private notificationService: NotificationService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {

      this.notificationService.audio.play();
      this.notifySound = true;

      this.takeDataFromAlarm();

      this.subscription = this.socketService.onAccept()
        .subscribe(data => {
          this.ngZone.run(() => {

            if (data.id == this.user.id) {
              this.activeModal.dismiss();

            }
              setTimeout(() =>
                  {
                      this.socketService.checkAlarms();
                  },
                  1500);

          });
        });

    });
  }

    takeDataFromAlarm(){
        this.notificationService.getAlarmUsers()
            .pipe(take(1))
            .subscribe(data => {
                if (data.length > 0) {
                    const index = data.findIndex(j => j.alarmID == this.user.alarmID);
                    this.alarm = data[index];
                }
            });
    }



  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleSound() {
    if (this.notificationService.audio.paused) {
      this.notificationService.audio.play();
      this.notifySound = true;
    } else {
      this.notificationService.audio.pause();
      this.notifySound = false;
    }
  }
}

/*
2:40661:42["sosAlert","{\"id\":33,\"first_name\":\"asd2\",\"last_name\":\"asd2\",\"timezone\":\"Europe/Warsaw\",\"imei\":100000000000005,\"avatar\":\"\",\"day\":1,\"start_hour\":\"00:00:00\",\"end_hour\":\"23:59:00\",\"discr\":\"alarmleavezone\",\"alarmID\":869,\"received_data\":1623668015,\"beacon_mac\":null,\"last_fall\":null,\"last_sos\":null,\"battery_level\":54,\"last_measurement\":null,\"latitude\":51.032616,\"longitude\":21.078121,\"bandType\":\"CARE\",\"pulse\":0,\"sat\":0,\"wear_error\":0,\"phone\":null,\"birth_date\":null,\"address\":\"YphL9JrojAOM0KRX96Mt+g==\",\"description\":null,\"sim_number\":null,\"my_group\":null,\"alarmMeasurement_id\":5709}"]661:42["sosAlert","{\"id\":33,\"first_name\":\"asd2\",\"last_name\":\"asd2\",\"timezone\":\"Europe/Warsaw\",\"imei\":100000000000005,\"avatar\":\"\",\"day\":1,\"start_hour\":\"00:00:00\",\"end_hour\":\"23:59:00\",\"discr\":\"alarmleavezone\",\"alarmID\":870,\"received_data\":1623668200,\"beacon_mac\":null,\"last_fall\":null,\"last_sos\":null,\"battery_level\":54,\"last_measurement\":null,\"latitude\":51.032616,\"longitude\":21.078121,\"bandType\":\"CARE\",\"pulse\":0,\"sat\":0,\"wear_error\":0,\"phone\":null,\"birth_date\":null,\"address\":\"YphL9JrojAOM0KRX96Mt+g==\",\"description\":null,\"sim_number\":null,\"my_group\":null,\"alarmMeasurement_id\":5710}"]
 */



// WEBPACK FOOTER //
// ./src/app/shared/components/sos-alert/sos-alert.component.ts